import $ from "jquery";
import objectFitImages from 'object-fit-images';

const App = (() => {
  return {
    gridGutterWidth: 30,
    gridGutterWidthHalf: 15,
    initialize: () => {
      const $column = $('div[class*="col-"]:first');
      if ($column.length > 0) {
        const gutterWidthHalf = parseInt($column.css('padding-left'));
        if (!isNaN(gutterWidthHalf)) {
          App.gridGutterWidthHalf = gutterWidthHalf;
          App.gridGutterWidth = gutterWidthHalf * 2;
        }
      }
      if (App.isInternetExplorer()) {
        $('html').addClass('ie');
        objectFitImages(null, {
          watchMQ: false,
        });
      }
    },
    isInternetExplorer: () =>
      !!navigator.userAgent.match(/Trident/g) ||
      !!navigator.userAgent.match(/MSIE/g) ||
      /* @cc_on!@ */false,
    doesUrlExist: (url, callback) => {
      $.ajax({
        type: 'HEAD',
        url: url,
        success: function () {
          callback(true);
        },
        error: function () {
          callback(false);
        }
      });
    },
    isGoogleLoaded: () => {
      return typeof window.google !== 'undefined';
    },
    cleanSelector: (selector) => {
      //noinspection SingleCharAlternation
      return typeof selector !== 'undefined' ? selector.toString().replace(/(:|\.|\[|]|,)/g, '\\$1') : '';
    },
    getUrlFilename: (url) => {
      if (url) {
        let m = url.toString().match(/.*\/(.+?)\./);
        if (m && m.length > 1) {
          return m[1];
        }
      }
      return '';
    },
    isTouchDevice: () => {
      try {
        document.createEvent("TouchEvent");
        return true;
      }
      catch(e) {
        return false;
      }
    },
    isJSONString: (str) => {
      try {
        if (typeof(str) === 'string') {
          if (str.length === 0) {
            return false;
          }
        }
        JSON.parse(str);
      }
      catch (e) {
        return false;
      }
      return true;
    },
    arrayContains: (arr, obj) => {
      let i = arr.length;
      while (i--) {
        if (arr[i] === obj) {
          return true;
        }
      }
      return false;
    },
    adjustTime: (date) => {
      if(typeof SERVER_TIME_DIFFERENCE !== 'undefined') {
        return new Date(date.getTime() - SERVER_TIME_DIFFERENCE);
      }
      return date;
    },
    getDate: () => {
      if(typeof SERVER_TIME_DIFFERENCE !== 'undefined') {
        return new Date(new Date().getTime() - SERVER_TIME_DIFFERENCE);
      }
      return new Date();
    }
  };
})();

module.exports = App;
